export default __webpack_public_path__ + "static/media/G0670.34I-26412_-16225_0.1715850360000.28b75511.jpg";